const CONSENT_KEY = "yogyism:consentAccepted:v1";
const CONSENT_VERSION = "v1";

export function hasConsented(): boolean {
  try {
    const raw = localStorage.getItem(CONSENT_KEY);
    if (!raw) return false;
    const parsed = JSON.parse(raw);
    return parsed?.version === CONSENT_VERSION;
  } catch {
    return false;
  }
}

export function writeConsent() {
  try {
    localStorage.setItem(CONSENT_KEY, JSON.stringify({
      version: CONSENT_VERSION,
      acceptedAt: Date.now(),
    }));
  } catch {}
}